import { LogicModel } from "../LogicModel";
import { isNullOrEmpty } from "../../utils";
import { LogicType } from "../enums/LogicType";

export function createLogic(el?: string): LogicModel {
    if (el == null || isNullOrEmpty(el)) return undefined;
    return {
        type: el.startsWith("logic:adv") ? LogicType.Advanced : LogicType.Simple,
        expression: el.substr(el.indexOf(";") + 1),
    };
}
